import React, { PropsWithChildren, ReactElement } from "react"
import Dock from "../dock"

import modStyl from "./index.module.scss"

type Props = {
  children: ReactElement
}
const WithDockLayout: React.FC<Props> = ({ children })=> {
  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.container}>
        {children}
      </div>
      <Dock/>
    </div>
  )
}

export default WithDockLayout